import React, { useRef, useState } from "react";
import { cn } from "../lib/utils";
import { uploadFileToAzure } from "../services/helper";
import styles from "./file-picker.module.css";
export default function FilePicker({
  showContainer,
  attachmentUrl,
  setAttachmentUrl,
  attachmentLoading,
  setIsAttachmentLoading,
}) {
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const fileInputs = Array.from(event.target.files);

    if (fileInputs.length > 0 && !attachmentLoading) {
      try {
        setIsAttachmentLoading(true);

        // Check if adding these files would exceed the limit
        const totalFiles = files.length + fileInputs.length;
        if (totalFiles > 5) {
          alert("Maximum 5 files allowed");
          return;
        }

        // Upload all files
        const uploadPromises = fileInputs.map((file) => uploadFileToAzure(file, "dm2buy"));
        const uploadedUrls = await Promise.all(uploadPromises);

        // Update state
        const newFiles = fileInputs.map((file, index) => ({
          file,
          url: uploadedUrls[index],
        }));

        setFiles((prev) => [...prev, ...newFiles]);
        setAttachmentUrl((prev) => [...(prev || []), ...uploadedUrls]);
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        setIsAttachmentLoading(false);
      }
    }

    // const fileInput = event.target.files[0];
    // if (fileInput && !attachmentLoading) {
    //   try {
    //     setFile(fileInput);
    //     setIsAttachmentLoading(true);
    //     const uploadedUrl = await uploadFileToAzure(fileInput, "dm2buy");
    //     setAttachmentUrl(uploadedUrl);
    //   } catch (error) {
    //     console.error("Error uploading file:", error);
    //   } finally {
    //     setIsAttachmentLoading(false);
    //   }
    // }
  };

  // const handleRemoveFile = () => {
  //   setFile(null);
  //   setAttachmentUrl(null);
  //   fileInputRef.current.value = "";
  // };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
    setAttachmentUrl((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  if (!showContainer) return null;

  return (
    <div>
      {/* Always show the select button if under limit */}
      {files.length < 5 && (
        <button
          className={cn(styles.customButton, "!border-fontBackground !text-fontBackground")}
          onClick={triggerFileInput}
          disabled={attachmentLoading}
        >
          {attachmentLoading ? "Uploading..." : "Select files"}
        </button>
      )}

      {/* Show selected files */}
      {files.length > 0 && (
        <div className={styles.fileDisplay}>
          {files.map((fileObj, index) => (
            <div
              key={index}
              className="mb-2 flex items-center justify-between rounded border bg-white p-2"
            >
              <h3 className={styles.fileName}>{fileObj.file.name}</h3>
              <button className={styles.removeButton} onClick={() => handleRemoveFile(index)}>
                &times;
              </button>
            </div>
          ))}
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        accept="image/*"
        multiple
        onChange={handleFileChange}
        className={styles.hiddenInput}
      />

      <h3 className={styles.maxFileWarning}>
        This product supports customisations. Upload reference photos (max 5 files, 5MB each)
      </h3>
    </div>
  );
}
